<template>
  <va-card :title="$t('menu.clients')">
    <div class="row">
      <div class="flex xs12 md4">
        <va-input
          v-model="searchName"
          :label="$t('tables.company')"
          removable
        >
        </va-input>
      </div>
      
      <div class="flex md1">
        <va-button
          small
          color="secondary"
          icon="fa fa-search"
          class="ma-2"
          @click="readItems(page, searchName)"
        >
          {{ $t('menu.search') }}
        </va-button>
      </div>

      <div class="flex xs12 md3 offset--md3">
        <va-select
          v-model="perPage"
          :value="perPage"
          :label="$t('tables.perPage')"
          :options="perPageOptions"
        />
      </div>
    </div>

    <div class="flex xs12 sm3">
      <va-button v-if="ability.can('create', 'Clients')"
        medium
        inline
        color="secondary"
        icon="fa fa-plus"
        class="ma-0"
        :to="{ name: 'form-clients' }" 
      >
        {{ $t('menu.new') }}
      </va-button>
  
      <va-button v-if="ability.can('import', 'Clients')"
        medium
        inline
        color="secondary"
        icon="fa fa-cloud-upload"
        class="ml-2"
        to="/admin/import-clients"
      >
        {{ $t('menu.import') }}
      </va-button>

    </div>

    <div v-show="loading" class="text--center pb-4">
      <div class="flex-center spinner-box">
        <slot name="loading">
          <spring-spinner
            slot="loading"
            :animation-duration="currentDuration"
            :is="spload.name"
            :color="spinnersColor"
            :size="config.size"
          />
        </slot>
      </div>
    </div>

    <va-data-table
      :fields="fields"
      :data="data"
      :per-page="parseInt(perPage)"
      :total-pages="parseInt(totalPages)"
      api-mode
      no-pagination
      v-show="!loading"
      @page-selected="readItems"
    >

    <template slot="actions" slot-scope="props">
      <va-button v-if="ability.can('update', 'Clients')"
        small
        inline
        color="green"
        icon="fa fa-edit"
        class="ma-0"
        :to="{ name: 'form-clients', params: { id: props.rowData.id, current_page: current_page, searchName: searchName, perPage: perPage } }" 
      >
        {{ $t('menu.edit') }}
      </va-button>
      <va-button v-if="ability.can('destroy', 'Clients')"
        small 
        inline 
        color="danger" 
        icon="fa fa-remove"
        class="ma-1"
        @click="showModalRemove = true, codeClient = props.rowData.id" 
      >
        {{ $t('tables.delete') }}
      </va-button>
    </template>
    </va-data-table>

      <Pagination 
        :currentPage="current_page"
        :totalPages="totalPages"
        :onChange="onPageChange"
        v-show="!loading"
      />

      <va-modal
        v-model="showModalRemove"
        size="small"
        :title="$t('modal.remove')"
        :message="$t('modal.messageRemoveClient')"
        hideDefaultActions
        :color="this.$themes.secondary"
      >

      <va-button
        color="danger"
        class="ma-2"
        @click="showModalRemove = false">
        {{$t('modal.cancel')}}
      </va-button>

      <va-button
        color="green"
        class="ma-2"
        @click="remove(codeClient), showModalRemove = false">
        {{$t('modal.confirm')}}
      </va-button>
    </va-modal>
  </va-card>
</template>

<script>

import ClientAPI from '@/services/ClientAPI'
import * as spinners from 'epic-spinners'
import moment from 'moment';

import { mapState } from "vuex";
import { Ability } from '@casl/ability'
export const ability = new Ability()

import Pagination from '../../shared/Pagination'

export default {
  components: {
    ...spinners,
    Pagination
  },
  data () {
    return {
      ability: [],
      data: [],
      term: null,
      loading: false,
      config: {
        size: 80,
        group: 4,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      showModalRemove: false,
      codeClient: "",
      searchName: "",
      perPage: "10",
      totalPages: 0,
      perPageOptions: ['10', '20', '30', '50'],
      id: '',
      current_page: ''
    }
  },

  channels: {
    NeedRefreshClients: {
      received(data) {
        this.readItems()
      },
    }
  },

  beforeMount(){
    this.ability = ability.update(this.rules)
  },

  mounted () {
    this.$cable.subscribe({ channel: 'NeedRefreshClients', company: this.currentUser.company })
    
    this.perPage = (this.$route.params.perPage !== undefined) ? `${this.$route.params.perPage}` : "10"
    this.searchName = (this.$route.params.searchName !== undefined) ? `${this.$route.params.searchName}` : ""

    this.readItems(this.$route.params.current_page, this.searchName)

  },

  filters: {
    formatDateToTime: function(value) {
      if (value) {
        return moment(String(value)).format('hh:mm')
      }
    }
  },
  computed: {
    ...mapState(["rules", 'currentUser']),

    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.clients.id'),
        width: '5%',
      },
      {
        name: 'name',
        title: this.$t('tables.clients.name'),
        width: '20%',
      },
      {
        name: 'address',
        title: this.$t('tables.clients.address'),
        width: '20%',
      },
      {
        name: 'city',
        title: this.$t('tables.clients.city'),
        width: '10%',
      },
      {
        name: 'state',
        title: this.$t('tables.clients.state'),
        width: '5%',
      },
      {
        name: 'start_of_service',
        title: this.$t('tables.clients.start_of_service'),
        width: '10%',
      },
      {
        name: 'end_of_service',
        title: this.$t('tables.clients.end_of_service'),
        width: '10%',
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
        width: '15%',
      }]
    },
    spload () {
      // return spinners.SpinnerName
      return spinners.ScalingSquaresSpinner
    }
  },
  watch: {
    perPage: function (newVal) {
      this.perPage = newVal
      this.readItems(this.current_page)
    },
    searchName: function (newVal) {
      if (!newVal) {
        this.readItems()
      }
    }
  },
  created () {
    this.readItems()
  },
  methods: {
    onPageChange(page) {
      this.readItems(page)
    },
    readItems(page, searchName) {
      this.loading = true

      const params = {
        page: page,
        quantity: this.perPage,
        name: this.searchName
      }
      this.current_page = this.$route.params.current_page

      ClientAPI.getFilteredClients(params)
        .then(response => {
          this.totalPages = response.data.total_pages
          this.current_page = response.data.current_page
          this.data = response.data.clients
          this.loading = false
        })
    },
    remove (clientId) {
      ClientAPI.deleteClient(clientId)
        .then(response => {
          const rowItem = this.data.map((e) => e.id).indexOf(clientId)
          this.data.splice(rowItem, 1)

          this.showToast(response.data.message, {
            icon: 'fa-thumbs-o-up',
            position: 'top-right',
            duration: 5000,
          })
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    }
  }
}
</script>

<style lang="scss">
</style>
